import { TimeSpans } from '../../constants/utility/time-spans.constants';
import { getAuthApi } from '../context/auth-context';

const REFRESH_BEFORE_EXPIRY_MS = TimeSpans.FiveMinutes;
let tokenExpiryTimeout = null;
let accessTokenExpiry = null;

export function scheduleTokenRefresh(expiryUtc) {
    if (!expiryUtc) return;

    const expiry = new Date(expiryUtc);
    accessTokenExpiry = expiry;

    if (tokenExpiryTimeout) {
        clearTimeout(tokenExpiryTimeout);
    }

    const now = Date.now();
    const expiryMs = expiry.getTime();
    const refreshAt = expiryMs - REFRESH_BEFORE_EXPIRY_MS;
    const delay = Math.max(0, refreshAt - now);

    console.debug(
        '[token-refresh] Scheduled refresh in',
        Math.round(delay / 1000),
        'seconds (5 min before expiry)'
    );

    tokenExpiryTimeout = setTimeout(async () => {
        console.debug('[token-refresh] Proactively refreshing token before expiry');
        try {
            const authApi = getAuthApi();
            await authApi.refresh();
            console.debug('[token-refresh] Proactive refresh succeeded');
        } catch (err) {
            console.warn('[token-refresh] Proactive refresh failed:', err);
        }
    }, delay);
}

export function clearTokenRefreshSchedule() {
    if (tokenExpiryTimeout) {
        clearTimeout(tokenExpiryTimeout);
        tokenExpiryTimeout = null;
    }
    accessTokenExpiry = null;
}

export function getAccessTokenExpiry() {
    return accessTokenExpiry;
}
